import { grayscale } from "./grayscale";
import { material } from "./material";
export * from "./types";
export const VictoryTheme = {
  grayscale,
  material
};